import env from "../../env";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const jwtHeaders = () => ({
  jwt: localStorage.getItem("microsoftJWT"),
  Accept: "application/json",
  "Content-Type": "application/json",
});

const sanitizeWarehouseData = (raw) => {
  const input = { ...(raw || {}) };
  const trimStr = (v) => (typeof v === 'string' ? v.trim() : v);
  const nullIfEmpty = (v) => (v === '' || v === undefined ? null : v);

  const sanitized = {
    name: nullIfEmpty(trimStr(input.name)),
    skuNumber: nullIfEmpty(trimStr(input.skuNumber)),
    serial: nullIfEmpty(trimStr(input.serial)),
    ean: nullIfEmpty(trimStr(input.ean)),
    description: nullIfEmpty(trimStr(input.description)),
    shelves: nullIfEmpty(trimStr(input.shelves)),
    skCode: nullIfEmpty(trimStr(input.skCode)),
  };
  const qty = input.quantity;
  sanitized.quantity = qty === '' || qty === undefined || qty === null || Number.isNaN(Number(qty)) ? null : Number(qty);

  Object.keys(sanitized).forEach((k) => {
    if (sanitized[k] === undefined) delete sanitized[k];
  });
  return sanitized;
};

export const getAllWarehouse = createAsyncThunk(
  "warehouse/getAllWarehouse",
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${env.API_URL}/warehouses?pagination[pageSize]=10000`,
        { headers: jwtHeaders() }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const createWarehouseItem = createAsyncThunk(
  "warehouse/createWarehouseItem",
  async (payload, { rejectWithValue }) => {
    try {
      const input = payload?.data ? payload.data : payload;
      const body = { data: sanitizeWarehouseData(input) };
      const { data } = await axios.post(`${env.API_URL}/warehouses`, body, {
        headers: jwtHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: "Unknown error" });
    }
  }
);

export const updateWarehouseItem = createAsyncThunk(
  "warehouse/updateWarehouseItem",
  async ({ id, data: updateData }, { rejectWithValue }) => {
    try {
      const body = { data: sanitizeWarehouseData(updateData) };
      const { data } = await axios.put(`${env.API_URL}/warehouses/${id}`, body, {
        headers: jwtHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: "Unknown error" });
    }
  }
);

export const deleteWarehouseItem = createAsyncThunk(
  "warehouse/deleteWarehouseItem",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${env.API_URL}/warehouses/${id}`, {
        headers: jwtHeaders(),
      });
      return { id, res: data };
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? { message: "Unknown error" });
    }
  }
);
